import { TOUR } from "../tourTargets";
import { useVisibleAnchors } from "../anchors";
import CoachMark from "./CoachMark";

/**
 * Stage-1 coach mark for a workspace with nothing in it: points at the
 * navbar's add-reading control (the ResourceSelector empty state).
 * Shown when sample content isn't there — seeding failed, or the user
 * cleared their workspace.
 */
interface Props {
  onDismiss: () => void;
}

const TARGETS = [TOUR.resourceSelector];

export default function FirstReadingPrompt({ onDismiss }: Props) {
  const anchors = useVisibleAnchors(TARGETS);
  const anchorEl = anchors[TOUR.resourceSelector];

  if (!anchorEl) {
    return null;
  }

  return (
    <CoachMark
      anchorEl={anchorEl}
      title="Add your first reading"
      body="Import a PDF here — highlighting a reading is where everything starts. A quick tour follows once it's open."
      placement="bottom-start"
      onDismiss={onDismiss}
    />
  );
}
